import React, { useState } from 'react';
import PayRateCalculator from './components/PayRateCalculator';
import AdminTool from './components/AdminTool';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('payrate');

  return (
    <div className="App">
      {/* Skip to main content link for accessibility */}
      <a
        href="#main-content"
        style={{
          position: 'absolute',
          top: '-40px',
          left: 0,
          background: 'var(--color-secondary)',
          color: 'white',
          padding: 'var(--spacing-sm) var(--spacing-md)',
          textDecoration: 'none',
          zIndex: 100,
        }}
        onFocus={(e) => (e.target.style.top = 0)}
        onBlur={(e) => (e.target.style.top = '-40px')}
      >
        Skip to main content
      </a>

      {/* Tab Navigation */}
      <nav
        className="tabs-container"
        role="tablist"
        aria-label="Main navigation"
      >
        <button
          className={`tab-button ${activeTab === 'payrate' ? 'active' : ''}`}
          onClick={() => setActiveTab('payrate')}
          aria-selected={activeTab === 'payrate'}
          aria-controls="payrate-panel"
          role="tab"
          id="payrate-tab"
        >
          <span style={{ marginRight: 'var(--spacing-sm)', ariahidden: 'true' }}>🧮</span>
          Pay Rate Calculator
        </button>
      </nav>

      {/* Content */}
      <main className="App-container" id="main-content">
        <div
          id="payrate-panel"
          role="tabpanel"
          aria-labelledby="payrate-tab"
          style={{ display: activeTab === 'payrate' ? 'block' : 'none' }}
        >
          <PayRateCalculator />
        </div>
        <div
          id="admin-panel"
          role="tabpanel"
          aria-labelledby="admin-tab"
          style={{ display: activeTab === 'admin' ? 'block' : 'none' }}
        >
          <AdminTool />
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        borderTop: '1px solid var(--color-border)',
        padding: 'var(--spacing-lg)',
        marginTop: 'var(--spacing-2xl)',
        textAlign: 'center',
        color: 'var(--color-text-tertiary)',
        fontSize: 'var(--font-size-sm)',
        backgroundColor: 'var(--color-bg-surface)',
      }}>
        <p style={{ margin: 0 }}>LVCALC © 2026 | Teacher Evaluation System</p>
      </footer>
    </div>
  );
}

export default App;
